import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

const Table = styled.table`
  border-radius: 14px;
  width: 100%;
  border: 1px solid #a1a1a1;
  background: #fafafa;
  text-align: left;
  font-size: 33px;
  table-layout: fixed;
  margin: 13px auto;

  th, td {
    font-color: #5e5e5e;
    font-weight: normal;
    padding: 36px 26px;
    border: none;
    border-bottom: 1px solid #a1a1a1;
    line-height: 1;
  }
  
  tr:last-child td {
    border-bottom: none;
  }

  td {
    color: #2c2c2c;
    font-style: italic;
  }
`;

class SimpleTable extends Component {
  render() {
    return (
      <Table>
        <thead>
          <tr>
            {this.props.columns.map(c => (
              <th key={c}>{c}</th>
          ))}
          </tr>
        </thead>
        <tbody>
          {
            this.props.rows.map((r, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <tr key={i}>
                {r.map((c, j) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <td key={j}>{c}</td>
                ))}
              </tr>
              ))
          }
        </tbody>
      </Table>
    );
  }
}

SimpleTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string),
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.any)),
};

SimpleTable.defaultProps = {
  columns: [],
  rows: [],
};

export default SimpleTable;



// WEBPACK FOOTER //
// ./src/components/simple-table.jsx